export const userGroup = (state = { userGroup: "others" }, action) => {
  switch (action.type) {
    case "SET_USER_GROUP":
      return { ...state, userGroup: action.payload };
    default:
      return state;
  }
};

export const maintenanceResortList = (state = { resortList: [] }, action) => {
  switch (action.type) {
    case "MAINTENANCE_RESORT_DATA":
      return { ...state, resortList: action.payload.data };

    case "MAINTENANCE_ERROR_RESORT_DATA":
      return {
        ...state,
        resortList: action.payload.detail ? action.payload : [],
      };
    default:
      return state;
  }
};
export const marshaCodeList = (state = { codeList: [] }, action) => {
  switch (action.type) {
    case "MARSHA_CODE_DATA":
      return { ...state, codeList: action.payload.data };
    case "MARSHA_ERROR_CODE_DATA":
      return {
        ...state,
        codeList: action.payload.detail ? action.payload : [],
      };
    default:
      return state;
  }
};
export const tabledataList = (state = { tableList: [] }, action) => {
  switch (action.type) {
    case "TABLE_DATA":
      return { ...state, tableList: action.payload.data };
    case "TABLE_ERROR_DATA":
      return {
        ...state,
        tableList: action.payload.detail ? action.payload : [],
      };
    default:
      return state;
  }
};
